import { ID } from 'shared/types/id';
import { otherSectionID } from 'shared/types/orderable-section';
export const getOtherSectionId = (goalId: ID) => `${otherSectionID}--${goalId}`;

export const isOtherSection = (sectionId: ID) =>
  sectionId.startsWith(otherSectionID);

export const getGoalIdFromOtherSectionId = (sectionId: ID) =>
  isOtherSection(sectionId) ? sectionId.split('--')[1] : undefined;
